import {
    SET_ALL_TOUCHED,
    SET_ERRORS,
    SET_IS_SUBMITTING,
    SET_TOUCHED,
    SET_VALUE,
    SET_POSSIBLE_CARD_TYPE
} from './action-types';

export const setValue = (name, value) => ({
    type: SET_VALUE,
    payload: {
        name,
        value
    }
});

export const setTouched = name => ({
    type: SET_TOUCHED,
    payload: {name}
});

export const setIsSubmitting = payload => ({
    type: SET_IS_SUBMITTING,
    payload
});

export const setAllTouched = () => ({
    type: SET_ALL_TOUCHED
});

export const setErrors = errors => ({
    type: SET_ERRORS,
    payload: errors
});

export const setCardType = possibleCardType => ({
    type: SET_POSSIBLE_CARD_TYPE,
    payload: possibleCardType
});
